import { Inject, Injectable } from '@angular/core';
import { CONFIG_APIS } from '@cargos/sprintpay-services';
import { DSVUser } from '../models/customers/dsv';
import { DynamicCompany } from '../models/customers/dynamic-company';
import { EmotransUser } from '../models/customers/emotrans';
import { ExpeditorsUser } from '../models/customers/expeditors';
import { GeodisUser } from '../models/customers/geodis';
import { KNUser } from '../models/customers/kn';
import { RhenusUser } from '../models/customers/rhenus';
import { SchenkerUser } from '../models/customers/schenker';
import { User } from '../models/customers/user';
import { Companies } from '../utils/requester-flow-levels/companies';

@Injectable({
    providedIn: 'root',
})
export class CustomerConfiguration {
    constructor(@Inject(CONFIG_APIS) private readonly apis: Record<string, string>) {}

    getCustomer(company?: string) {
        switch (company) {
            case Companies.SCHENKER:
                return new SchenkerUser(this.apis);
            case Companies.GEODIS:
                return new GeodisUser(this.apis);
            case Companies.KN:
                return new KNUser(this.apis);
            case Companies.EMOTRANS:
                return new EmotransUser(this.apis);
            case Companies.RHENUS:
                return new RhenusUser(this.apis);
            case Companies.EXPEDITORS:
                return new ExpeditorsUser(this.apis);
            case Companies.DSV:
                return new DSVUser();
            default:
                return company ? new DynamicCompany(this.apis) : User.fromJson({});
        }
    }
}
